import type { CuratedItem, VariationComponent } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
    checkMediaIntegrity,
    firstItemOnly,
} from "~utils/moduleIntegrity";

import { getMediaPriority } from "./LineupContentBasic";

export default function integrityCheck({
    items = [],
    renderingLocation,
}: VariationComponent): IntegrityStatus {
    const messages = checkItemArrayIntegrity(firstItemOnly<CuratedItem>(items));

    // This variation needs some form of multimedia to be valid.
    messages.push(
        ...checkMediaIntegrity(
            firstItemOnly<CuratedItem>(items),
            getMediaPriority(renderingLocation)
        )
    );

    return messages;
}
